import Vue from 'vue'
import Vuex from 'vuex'
import { isEmpty, forEach } from 'lodash'
/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'promoInfo'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        promoInfo:
        {
          busnCd: '',
          coGroupCode: 'B2C_18_001',
          contextPath: '',
          eduGroupCode: 'CUS0001',
          promoId: '',
          promoNm: '',
          virtualPath: '',
          facbkCtfcKeyCntnt: '',
          googlCtfcKeyCntnt: '',
          kakaoCtfcKeyCntnt: '',
          naverCtfcKeyCntnt: '',
          snsLoginMrkYn: '',
          activeYn: ''
        },
        productDetail: {
          productList: [],
          isVisible: true,
          selectedProductKey: ''
        }
      },
      getters: {
        getPromoInfo: state => {
          return state.promoInfo
        },
        getMmpUiBaseUrl: state => {
          let baseUrl = window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : ( ':' + window.location.port))
          let basePath = isEmpty(state.promoInfo.contextPath) ? '' : ('/' + state.promoInfo.contextPath)
          return (baseUrl + basePath)
        }
      },
      mutations: {
        // 토큰 저장
        SET_PROMO_INFO (state, promoInfo) {
          window._eventid = promoInfo.contextPath
          window._eventname = promoInfo.promoNm
          window._eventdomain = promoInfo.contextPath

          Vue.set(state, 'promoInfo', promoInfo)
        },
        SET_PRODUCT_LIST (state, list) {
          Vue.set(state.productDetail, 'productList', list)
          window._productinfo = []

          forEach(list, function (val) {
            window._productinfo.push({
              // 컬럼명 대소문자 차이 대비
              _product: val.corsNm || val.CORSNM,
              _courseid: val.corsCd || val.CORSCD,
              _price: val.ucstSmtotAmt || val.UCSTSMTOTAMT,
              _coursedate: (val.eduStartDtm || val.EDUSTARTDTM) + ',' + (val.eduEndDtm || val.EDUENDDTM)
            })
          })

          window.dataLayer.push({
            event: 'set_product'
          })
        },
        SET_PRODUCT_VISIBLE (state, isVisible) {
          Vue.set(state.productDetail, 'isVisible', isVisible )
        },
        SET_PRODUCT_SELECTED (state, seletedPrd) {
          Vue.set(state.productDetail, 'selectedProductKey', seletedPrd )
        },
        SET_PRODUCT_INFO (state, info) {
          window._productinfo = []
          window._productinfo.push({
            _product: info.corsNm,
            _courseid: info.corsCd,
            _price: info.ucstSmtotAmt,
            _coursedate: info.eduStartDtm + ',' + info.eduEndDtm
          })

          window.dataLayer.push({
            event: 'set_product'
          })
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/promo.js